import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {css} from 'aphrodite';
import {renderMultifieldString} from 'libs/salmon-utils';
import Markdown from 'components/Markdown';

/**
 * New Wrapper component to handle state for the coverage summary modal
 */
export const CoverageSummaryModal = (props) => {
  const {
    column,
    rowData,
    styleSheet,
    showSummaryModal,
    handleHide,
  } = props;

  if (!rowData) {
    return null;
  }

  return (
    <Modal
      show={showSummaryModal}
      onHide={handleHide}
      aria-labelledby={'summary-modal-title'}
      backdrop={true}
      size='lg'
      backdropClassName={css(styleSheet.modalBackdrop)}
      dialogClassName={`pal-modal ${css(styleSheet.coverageSummaryModal)}`}
      className={css(styleSheet.modal)}
    >
      <Modal.Header closeButton>
        <Modal.Title id={'summary-modal-title'} className={'summary-modal-title'}>
          {column.meta && column.meta.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={'summary-modal-body'}>
        <div>
          <div style={{marginBottom: '15px'}}>
            <label className={css(styleSheet.coverageSummaryModalLabel)}>
              <span>{renderMultifieldString(column.meta?.subtitle, rowData)}</span>
            </label>
          </div>
          <Markdown>
            {rowData[column.property]}
          </Markdown>
        </div>
      </Modal.Body>
      {column.meta.disclaimer &&
        <Modal.Footer className={css(styleSheet.coverageSummaryModalFooter)}>
          <Markdown>{column.meta?.disclaimer}</Markdown>
        </Modal.Footer>
      }
    </Modal>
  );
};